import { ActionTree } from 'vuex'
import { UserState, User } from '@/types/User'
import RootState from '@/types/RootState'
import APIClient from '@/API/APIClient'
import firebase from 'firebase'
import moment from 'moment'
import Vote from '@/types/Vote'

export const actions: ActionTree<UserState, RootState> = {
  async signIn ({ state, commit }): Promise<any> {
    await firebase.auth().signInAnonymously()
    firebase.auth().onAuthStateChanged((user) => {
      if (!(state.user && state.user.userID)) {
        const UIDUser: User = {
          userID: user!.uid,
          created: moment().valueOf(),
          displayName: ''
        }
        commit('setUser', UIDUser)
      }
    })
  },
  async joinRoom ({ state, commit, rootState }): Promise<any> {
    if (rootState.partyRoom.partyRoom && state.user) {
      APIClient.User.fetchUser(rootState.partyRoom.partyRoom.partyID, state.user.userID).then((userSnap) => {
        commit('setUser', userSnap.data())
      })
    } else {
      throw new Error('Partyroom or user was empty when we tried to fetch the user')
    }
  },
  async mountSongsVotedFor ({ state, commit, rootState }): Promise<void> {
    const votes = await firebase.firestore().collection('partyrooms')
      .doc(rootState.partyRoom.partyRoom?.partyID)
      .collection('votes')
      .where('userID', '==', state.user?.userID)
      .get()
    votes.docs.forEach((voteSnap) => {
      const externalVote = voteSnap.data()
      const vote: Vote = {
        requestID: externalVote.requestID,
        userID: externalVote.userID,
        voteID: voteSnap.id
      }
      commit('addSongVotedFor', vote)
    })
  }
}
